// recommendation-state.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, distinctUntilChanged } from 'rxjs';
import { CatalogRecommendation, CategoryRecommendation, ImageRecommendation, RecommendationState } from '../core/types';

@Injectable({ providedIn: 'root' })
export class RecommendationStateService {
    private stateSubject = new BehaviorSubject<RecommendationState>({
        currentStep: 'category',
        categories: [],
        selectedCategory: null,
        features: [],
        descriptions: { short: '', long: '' },
        loading: false,
        error: null,
        imageAnalysis: null,
        catalogs:[]
    });

    state$ = this.stateSubject.asObservable();

     // Get current state snapshot
  get currentState(): RecommendationState {
    return this.stateSubject.value;
  }

  // Update methods
  setLoading(loading: boolean): void {
    this.updateState({ loading });
  }

  setError(error: string | null): void {
    this.updateState({ error });
  }
  setCatalogStep():void{
    this.updateState({ currentStep:"catalog" });
  }

  updateCategories(categories: CategoryRecommendation[]): void {
    this.updateState({ categories });
  }

  updateCatalogs(catalogs: CatalogRecommendation[]): void {
    console.log("Catalogs updated", catalogs);
    this.updateState({ catalogs });
  }

  selectCategory(category: string): void {
    this.updateState({ 
      selectedCategory: category,
      currentStep: 'features'
    });
  }
  updateFeatures(features: string[]): void {
    this.updateState({ features });
  }
  updateImageAnalysis(analysis: ImageRecommendation): void {
    this.updateState({ imageAnalysis: analysis });
  }
  updateDescriptions(descriptions: Partial<RecommendationState['descriptions']>): void {
    this.updateState({ 
      descriptions: { 
        ...this.currentState.descriptions, 
        ...descriptions 
      }
    });
  }
  private updateState(update: Partial<RecommendationState>): void {
    this.stateSubject.next({
      ...this.currentState,
      ...update
    });
  }

  // Similar methods for features and descriptions updates
}